import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from 'redux'
import { AppReducer } from '../Components/App/Reducer/AppReducer'
import { LoginReducer } from '../Components/LoginForm/Reducer/LoginReducer'
import { LayoutReducer } from "../Components/Layouts/Reducer/LayoutReducer";
import { AdminAuthReducer } from '../Components/AdminAuth/Reducer/AdminAuthReducer';


const reducer = combineReducers({
  Apps: AppReducer,
  Login: LoginReducer,
  Layout: LayoutReducer,
  AdminAuth: AdminAuthReducer,


});

const store = configureStore({
  reducer,
})

export default store;